import { z } from "zod";

export const addResponseActionSchema = z.object({
  type: z.literal("ADD_RESPONSE"),
  payload: z.object({
    handlerId: z.number().int(),
    id: z.number().int(),
    label: z.string().optional(),
  }),
});

export type AddResponseAction = z.infer<typeof addResponseActionSchema>;

export const removeResponseActionSchema = z.object({
  type: z.literal("REMOVE_RESPONSE"),
  payload: z.object({
    id: z.number().int(),
  }),
});

export type RemoveResponseAction = z.infer<typeof removeResponseActionSchema>;

export const updateResponseActionSchema = z.object({
  type: z.literal("EDIT_RESPONSE"),
  payload: z.object({
    id: z.number().int(),
    label: z.string().optional(),
  }),
});

export type UpdateResponseAction = z.infer<typeof updateResponseActionSchema>;

export const reorderResponseActionSchema = z.object({
  type: z.literal("REORDER_RESPONSE"),
  payload: z.object({
    id: z.number().int(),
    newIndex: z.number().nonnegative(),
  }),
});

export type ReorderResponseAction = z.infer<typeof reorderResponseActionSchema>;
